






















































































import Vue from 'vue'
import { Component, Mixin, Lifecycle, Prop, p, Watch } from 'av-ts'
import { EventBus } from '@/eventbus'
import { VueUtils } from '@/mixins'
import { ILesson, languages, ITranslation } from '@/models'
import { notEmpty } from '@/utils'
import Sortable,{ SortableEvent } from 'sortablejs'
import { StoreType } from '@/store'

@Component({
  store: ['user']
})
export default class LessonWords extends Mixin(EventBus, VueUtils) {
  $store!: StoreType
  // lesson is passed by parent route
  @Prop lesson = p(Object) as ILesson

  error = undefined

  pagination = {
    sortBy: 'order',
    descending: true
  }
  // used for drag-n-drop functionality
  itemKeys = new WeakMap()
  currentItemKey = 0

  addForm = {
    srcWord: '',
    tgtWord: ''
  }

  tableFilterStr = undefined as string | undefined

  searchItemsLength = 0

  // workaround to get (filtered) items length
  @Watch('tableFilterStr')
  tableFilterChanged(newVal: string, oldVal: string) {
    if (newVal == oldVal) return
    this.$nextTick(() => {
      const tbl = this.$refs.sortableTable as any
      if (tbl)
        this.searchItemsLength = tbl.itemsLength
    })
  }

  /*
  // add drag-n-drop table ordering (with Sortable.js)
  @Watch('lesson')
  lessonChanged(newVal: ILesson | undefined, oldVal: ILesson | undefined) {
    console.debug('[EditLesson.vue] lessonChanged newVal, oldVal=', newVal, oldVal)
    // wait for the table to be created
    if (oldVal === undefined && newVal !== undefined) {
      this.$nextTick(() => {
        // at this point, the table should have been created ...

        // add drag-n-drop table ordering (with Sortable.js)
        // @see https://medium.com/vuetify/drag-n-drop-in-vuetify-part-ii-2b07b4b27684
        // @see https://codepen.io/webifi/pen/qPgbRK?editors=1010
        // @see https://github.com/vuetifyjs/vuetify/issues/2234
        const table = (this.$refs.sortableTable as Vue).$el
        Sortable.create(table.getElementsByTagName('tbody')[0], {
          handle: '.sort-handle',
          draggable: '.sortable-row',
          onEnd: this.dragReorder
        })
      })
    }
  }*/

  test() {
    console.debug('*** TEST ***')
  }

  @Lifecycle
  async created() {
    console.debug('[EditLesson.vue] created store=', this.$store)
    // console.debug('  lesson id =', this.id)
    // load lesson
    // this.lesson = await this.$store.getLesson(this.id)
    console.debug('lesson=', this.lesson)

    this.$nextTick(() => {
      // at this point, the table should have been created ...

      // add drag-n-drop table ordering (with Sortable.js)
      // @see https://medium.com/vuetify/drag-n-drop-in-vuetify-part-ii-2b07b4b27684
      // @see https://codepen.io/webifi/pen/qPgbRK?editors=1010
      // @see https://github.com/vuetifyjs/vuetify/issues/2234
      const table = (this.$refs.sortableTable as Vue).$el
      Sortable.create(table.getElementsByTagName('tbody')[0], {
        handle: '.sort-handle',
        draggable: '.sortable-row',
        onEnd: this.dragReorder
      })
    })

    // required to get correct filtered items length on component instantiation
    this.tableFilterStr = ''
  }

  // used for drag-n-drop functionality
  itemKey(item: any) {
    if (! this.itemKeys.has(item)) 
      this.itemKeys.set(item, ++this.currentItemKey)
    return this.itemKeys.get(item)
  }
  dragReorder(evt: SortableEvent) {
    if (evt.oldIndex !== undefined && evt.newIndex !== undefined && evt.oldIndex != evt.newIndex) {
      console.debug(`dragReorder oldIndex=[${evt.oldIndex}] newIndex=[${evt.newIndex}]`)
      this.swapWords(evt.oldIndex, evt.newIndex)
    }
  }

  addTranslations() {
    if (! this.lesson) throw new Error('No lesson to add words to !')
    const srcList = this.addForm.srcWord.split('/').filter(_ => notEmpty(_)).map(_ => _.trim())
    const tgtList = this.addForm.tgtWord.split('/').filter(_ => notEmpty(_)).map(_ => _.trim())
    console.debug('srcList, tgtList =', srcList, tgtList)
    let tslAdded = false
    if (srcList.length == 1 && tgtList.length == 1) { // common case: 1 word with 1 translation
      tslAdded = this.addTranslation(srcList[0], tgtList[0])
    } else if (srcList.length > 1 && tgtList.length > 1) {
      return EventBus.emitError('Cannot have multiple words and translations at the same time')
    } else if (srcList.length > 1) { // multiple source words with the same translation
      tslAdded = srcList.every(srcWord => this.addTranslation(srcWord, tgtList[0]))
    } else if (tgtList.length > 1) { // multiple translations for the source word
      tslAdded = tgtList.every(tgtWord => this.addTranslation(srcList[0], tgtWord))
    } else {
      return EventBus.emitError(`Unexpected case srcList.length=${srcList.toLocaleString} tgtList.length=${tgtList.length}`)
    }
    
    if (tslAdded) { // in case of error, don't empty fields
      this.addForm.srcWord = ''
      this.addForm.tgtWord = ''
    }
    this.setFocus(this.$refs['srcWordTxtField'])
  }

  private addTranslation(srcWord: string, tgtWord: string) {
    if (! this.lesson) throw new Error('No lesson to add words to !')
    // get order number : max order item in array + 1
    const order = this.lesson.words.reduce((rslt, tsl) => Math.max(rslt, tsl.order), -1) + 1
    const tsl: ITranslation = { _id: null, srcWord, tgtWord, order }
    const index = this.lesson.words.findIndex((item) => item.srcWord === tsl.srcWord && item.tgtWord === tsl.tgtWord)
    if (index != -1) {
      EventBus.emitError(`This translation already exists (${srcWord} -> ${tgtWord}) !`)
      return false
    } else {
      this.lesson.words.push(tsl)
      this.saveWord(tsl)
      return true
    }
  }

  removeTranslation(itrans: ITranslation) {
    if (! this.lesson) throw new Error('No lesson to add words to !')
    const index = this.lesson.words.findIndex(_ => _ == itrans)
    if (index == -1)
      EventBus.emitError(`Cannot remove translation ${itrans}, it was not found in list`)
    else {
      this.lesson.words.splice(index, 1)
      this.deleteWord(itrans)
    }
  }

  swapWords(oldIndex: number, newIndex: number) {
    if (oldIndex != newIndex) {
      const items = this.lesson!.words
      const movedItem = items.splice(oldIndex, 1)[0]
      items.splice(newIndex, 0, movedItem)

      // re-order items (update the order attribute)
      const startIdx = Math.min(oldIndex, newIndex)
      // find max order amongst untouched items
      let order = startIdx == 0 ? 0 : items.reduce((rslt, tsl) => Math.max(rslt, tsl.order), -1) + 1
      // and then update all touched items
      for (let i = startIdx; i < items.length; i++) {
        items[i].order = order++
      }

      // save impacted words
      this.saveWords(items.slice(startIdx))
    }
  }

  wordChanged(tsl: ITranslation) {
    console.debug('wordChanged arguments=', arguments)
    this.saveWord(tsl)
  }

  getHeaders() {
    return [
      { width: '10px', value: 'order' },
      { text: this.lesson ? this.getLangName(this.lesson.srcLang) : 'srcLang' , value: 'srcWord' }, 
      { text: this.lesson ? this.getLangName(this.lesson.tgtLang) : 'tgtLang' , value: 'tgtWord' },
      { sortable: false, text: '', value: undefined }
    ]
  }

  getLangName(code: string): string {
    const lang = languages.find(_ => _.code === code)
    return lang ? lang.name : '???'
  }

  private saveWord(word: ITranslation) {
    if (this.lesson)
      this.$store.saveLessonWord(this.lesson, word)
  }

  private saveWords(words: ITranslation[]) {
    if (this.lesson)
      this.$store.saveLessonWords(this.lesson, words)
  }

  private deleteWord(word: ITranslation) {
    if (this.lesson)
      this.$store.deleteLessonWord(this.lesson, word)
  }
}
